import { render, staticRenderFns } from "./Marketing-reports.vue?vue&type=template&id=06c92a8c"
import script from "./Marketing-reports.vue?vue&type=script&lang=js"
export * from "./Marketing-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports